// // =============================================
// // File: src/services/authService.js
// // =============================================

// import axiosInstance from "./axiosConfig";

// const authService = {
//   // Login user
//   login: async (credentials) => {
//     try {
//       const response = await axiosInstance.post("/user/login", credentials);
//       if (response.token) {
//         localStorage.setItem("token", response.token);
//         localStorage.setItem("user", JSON.stringify(response.user));
//       }
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Register new user
//   register: async (userData) => {
//     try {
//       const response = await axiosInstance.post("/user/signup", userData);
//       if (response.token) {
//         localStorage.setItem("authToken", response.token);
//         localStorage.setItem("user", JSON.stringify(response.user));
//       }
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Logout user
//   logout: async () => {
//     try {
//       await axiosInstance.post("/user/logout");
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("user");
//       window.location.href = "/login";
//     } catch (error) {
//       // Even if API call fails, clear local storage
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("user");
//       window.location.href = "/login";
//     }
//   },

//   // Refresh token
//   refreshToken: async () => {
//     try {
//       const response = await axiosInstance.post("/auth/refresh");
//       if (response.token) {
//         localStorage.setItem("authToken", response.token);
//       }
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Get current user
//   getCurrentUser: async () => {
//     try {
//       const response = await axiosInstance.get("/auth/me");
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Forgot password
//   forgotPassword: async (email) => {
//     try {
//       const response = await axiosInstance.post("/auth/forgot-password", {
//         email,
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Reset password
//   resetPassword: async (token, password) => {
//     try {
//       const response = await axiosInstance.post("/auth/reset-password", {
//         token,
//         password,
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// export default authService;

// =============================================
// File: src/services/authService.js
// =============================================

import axiosInstance from "./axiosConfig";

const authService = {
  // Login user
  login: async (credentials) => {
    try {
      const response = await axiosInstance.post("/user/login", credentials);
      if (response.token) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("user", JSON.stringify(response.user));
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Register new user
  register: async (userData) => {
    try {
      const response = await axiosInstance.post("/user/signup", userData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Verify OTP
  verifyOTP: async (data) => {
    try {
      const response = await axiosInstance.post("/user/verifyOtp", data);
      if (response.token) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("user", JSON.stringify(response.user));
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Resend OTP
  resendOTP: async (data) => {
    try {
      const response = await axiosInstance.post("/user/sendOtp", data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Logout user
  logout: async () => {
    try {
      await axiosInstance.post("/user/logout");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    } catch (error) {
      // Even if API call fails, clear local storage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
  },

  // Refresh token
  refreshToken: async () => {
    try {
      const response = await axiosInstance.post("/auth/refresh");
      if (response.token) {
        localStorage.setItem("token", response.token);
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get current user
  getCurrentUser: async () => {
    try {
      const response = await axiosInstance.get("/auth/me");
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Forgot password
  forgotPassword: async (email) => {
    try {
      const response = await axiosInstance.post("/user/sendOtp", { email });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Reset password
  resetPassword: async (data) => {
    try {
      const response = await axiosInstance.post("/user/resetPassword", data);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default authService;
